// eslint-disable-next-line simple-import-sort/imports
import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useMutation } from '@tanstack/react-query'
import AuthFaberApi from 'api/faber/AuthAPI'
import OrbitSession from 'hooks/useCookies'
import { Navigate, Route, Routes } from 'react-router-dom'
import Layout from 'common/Layout/Nav'
import {
  AccountManagement,
  AddAccount,
  AddCustomer,
  BillManagement,
  ConfirmQuotation,
  CustomerManagement,
  CustomerSupportPage,
  HandleOrderDeliveryPage,
  InventoryManagement,
  ManualProvisionOrderPage,
  ManualDeliveryMain,
  OrderManagementPage,
  PermissionedRoute,
  Profile,
  ProvisionOrderPage,
  QuotationManagement,
  ViewAndUpdateAccount,
  ViewAndUpdateCustomer,
  SimDetails,
  ViewIndividualOrderPage,
  PaymentManagementPage,
  IndividualOrderPage,
  FinanceMainDashboard,
  FaberOrOrbitVouchers,
  FaberFinanceMainDashboard,
  FaberStatusDashboard,
  FaberCustomerManagement,
  FaberVouchersMainDashboard,
  FaberVouchersUploadPage,
  FaberViewProfilePage
} from 'pages'

import FaberTerminatedCustomersMainDashboard from 'pages/Vouchers/Vendor/Faber/FaberTerminatedCustomersDashboard'
import FaberCatalogueDashboard from 'pages/ProductCatalogue/Faber/FaberCatalogueDashboard'
import FaberRewardsDashboard from 'pages/Rewards/Faber/FaberRewardsDashboard'
import FaberOtpDashboard from 'pages/Otpack/Faber/FaberOtpDashboard'
import FaberViewProfilePageV2 from 'pages/Customers/vendor/Faber/otpackComponents/FaberViewProfilePageV2'
import FaberGlobalDashboard from 'pages/Otpack/Faber/FaberGlobalDashboard'

// Global Toast Container

function VendorApp() {
  const token = OrbitSession.get('faberToken')
  const navigate = useNavigate()

  const { mutate: validateToken } = useMutation(AuthFaberApi.validateToken, {
    onError: () => {
      navigate('/login')
    }
  })

  useEffect(() => {
    if (token) {
      validateToken({ faberToken: token })
    }
  }, [token])

  return (
    <Routes>
      {/* BASE ROUTES */}
      <Route path='/' element={<Layout />}>
        <Route index element={<Navigate to='manage-customers-orbit' />} />
        <Route path='profile' element={<Profile />} />
        <Route path='manage-orders'>
          <Route index element={<OrderManagementPage />} />
        </Route>

        <Route path='manage-orders/individual-order/:id'>
          <Route index element={<IndividualOrderPage />} />
          <Route path='manual-delivery' element={<ManualDeliveryMain />} />
        </Route>

        <Route
          path='manage-orders/:orderId'
          element={<ViewIndividualOrderPage />}
        />
        <Route
          path='manage-orders/:orderId/manual-provision'
          element={<ManualProvisionOrderPage />}
        />
        <Route
          path='manage-orders/:orderId/handle-order-delivery'
          element={<HandleOrderDeliveryPage />}
        />

        <Route path='manage-customers-orbit'>
          <Route index element={<CustomerManagement />} />
          <Route path='add' element={<AddCustomer />} />
          <Route path='view' element={<ViewAndUpdateCustomer />} />
          <Route path='edit-sim' element={<SimDetails />} />
        </Route>

        <Route path='manage-customers-faber'>
          <Route index element={<FaberCustomerManagement />} />
          <Route path='view-profile/:id' element={<FaberViewProfilePage />} />
        </Route>
        <Route path='finance-orbit'>
          {/* <Route index element={<FaberOrOrbitFinance />} /> */}
          <Route index element={<FinanceMainDashboard />} />
        </Route>
        <Route path='finance-faber' element={<FaberFinanceMainDashboard />} />
        <Route path='status-faber' element={<FaberStatusDashboard />} />

        <Route path='manage-quotation' element={<QuotationManagement />} />
        <Route path='manage-catalogue'>
          <Route index element={<FaberCatalogueDashboard />} />
        </Route>
        <Route path='manage-rewards'>
          <Route index element={<FaberRewardsDashboard />} />
        </Route>
        <Route path='manage-otpack'>
          <Route index element={<FaberOtpDashboard />} />
          <Route path='view-profile/:id' element={<FaberViewProfilePageV2 />} />
          <Route
            path='manage-catalogue'
            element={<FaberCatalogueDashboard />}
          />{' '}
        </Route>
        <Route path='manage-global-cx'>
          <Route index element={<FaberGlobalDashboard />} />
          <Route
            path='view-profile/:id'
            // element={<FaberGlobalUserProfilePage />}
            element={<FaberViewProfilePageV2 />}
          />
        </Route>

        <Route path='manage-inventory'>
          <Route index
            element={<InventoryManagement />}
          />
        </Route>
        <Route path='confirm-quotation' element={<ConfirmQuotation />} />
        <Route path='manage-bill' element={<BillManagement />} />
        <Route
          path='provision-order/:orderId'
          element={<ProvisionOrderPage />}
        />
        <Route path='customer-support' element={<CustomerSupportPage />} />
        <Route path='manage-payment' element={<PaymentManagementPage />} />

        <Route path='manage-vouchers-orbit'>
          <Route index element={<FaberOrOrbitVouchers />} />
        </Route>
        <Route path='manage-vouchers-faber'>
          <Route index element={<FaberVouchersMainDashboard />} />
          <Route path='upload' element={<FaberVouchersUploadPage />} />
        </Route>
        <Route path='manage-terminated-faber'>
          <Route index element={<FaberTerminatedCustomersMainDashboard />} />
        </Route>

        {/* ROOT ONLY ROUTES */}
        <Route element={<PermissionedRoute allowedRoles={['opsowner']} />}>
          <Route path='manage-accounts'>
            <Route index element={<AccountManagement />} />
            <Route path='add' element={<AddAccount />} />
            <Route path='view' element={<ViewAndUpdateAccount />} />
          </Route>
        </Route>
      </Route>
    </Routes>
  )
}

export default VendorApp
